import { useMemo, useCallback, useState } from 'react';
import { useGlobal } from 'reactn';
import { isPermitted } from '../../../../../components/permission-control/permission-control';
import { FEED_CREATE_ATTORNEY } from '../../FeedPermission';

/**
 * Hook to manage attorney messaging modal visibility
 * Checks if user has permission to open the attorney conversation flow from the new message modal
 * @param {Function} onCloseNewMessageModal - Callback to close the NewMessageModal when opening AttorneyModal
 * @returns {Object} Object containing canShowAttorneyLink, showAttorneyModal, handleOpenAttorneyModal, handleCloseAttorneyModal
 */
export const useAttorneyMessagingHook = (onCloseNewMessageModal) => {
  const [global] = useGlobal();
  const [showAttorneyModal, setShowAttorneyModal] = useState(false);

  const canShowAttorneyLink = useMemo(() => {
    const { cbacConfigFlag, permissions, permissionIds } = global;

    return isPermitted(
      cbacConfigFlag,
      permissions,
      FEED_CREATE_ATTORNEY,
      permissionIds
    );
  }, [global.cbacConfigFlag, global.permissions, global.permissionIds]);

  const handleOpenAttorneyModal = useCallback(() => {
    if (onCloseNewMessageModal) {
      onCloseNewMessageModal();
    }
    setShowAttorneyModal(true);
  }, [onCloseNewMessageModal]);

  const handleCloseAttorneyModal = useCallback(() => {
    setShowAttorneyModal(false);
  }, []);

  return {
    canShowAttorneyLink,
    showAttorneyModal,
    handleOpenAttorneyModal,
    handleCloseAttorneyModal,
  };
};
